import { handleActions } from 'redux-actions'
import {
  actionsTypesGenerator,
  onRequest,
  onSuccess,
  onFailure,
} from 'utils/reduxHelpers'
import initialState from '../initialState'

const namespace = 'USER'
const UPDATE_USER = actionsTypesGenerator(`UPDATE_${namespace}`)

export const updateUser = (data) => ({
  types: UPDATE_USER,
  callAPI: {
    method: 'PATCH',
    entity: 'User',
    path: `/v2/users/${data.id}`,
    data,
  },
})

export default handleActions(
  {
    [UPDATE_USER.request]: onRequest,
    [UPDATE_USER.success]: (state, { response: { data = {} } }) => {
      return onSuccess({
        ...state,
        current: data,
      })
    },
    [UPDATE_USER.failure]: onFailure,
  },
  initialState.users
)
